import { useCallback } from "react";
import useTrackerContext from "../useTrackerContext.js";
import useGlobalContext from "../useGlobalContext.js";
import useUserAgent from "../useUserAgent.js";
const ACTION_NAME = "flights__genius_airlines_banner";
const ACTION_VERSION = "2.0.x";
export const useGeniusAirlinesBannerEvent = () => {
    const { trackExternal } = useTrackerContext();
    const { isMobile } = useUserAgent();
    const { analyticSessionId, isOfMetaOrigin, marketingTrackingVariables, uvi } = useGlobalContext();
    return useCallback((airlines) => {
        const trackingData = {
            analyticSessionId,
            isMobile,
            marketingTrackingVariables,
            uvi,
            isOfMetaOrigin
        };
        const content = {
            airlines,
            platform: trackingData.isMobile ? "mdot" : "desktop",
            session_id: trackingData.analyticSessionId || "",
            uvi: trackingData.uvi || "",
            aid: trackingData.marketingTrackingVariables?.aid || "",
            channel: trackingData.isOfMetaOrigin ? "meta" : "direct"
        };
        trackExternal({
            type: "c360",
            args: [
                {
                    action_name: ACTION_NAME,
                    action_version: ACTION_VERSION,
                    content
                }
            ]
        });
    }, [analyticSessionId, isMobile, marketingTrackingVariables, trackExternal, uvi, isOfMetaOrigin]);
};
export default useGeniusAirlinesBannerEvent;
